import $apiJSON from '../http/apiJSON'

export async function submitSnakeScore(score) {
  const response = await $apiJSON.post('account/snake/score/', { score })
  return response.data
}

export async function getMySnakeScore() {
  const response = await $apiJSON.get('account/snake/score/')
  return response.data
}

export async function getSnakeLeaderboard() {
  const response = await $apiJSON.get('account/snake/leaderboard/')
  return response.data
}
